import axios from "axios";
import React, { useEffect, useState } from "react";
import { CountryDropdown } from "react-country-region-selector";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import OtpInput from "react-otp-input";

import "react-phone-number-input/style.css";

const FirmProfileForm = ({ data, token }) => {
  const [firmName, setFirmName] = useState("");
  const [email, setEmail] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [compnayPan, setCompanyPan] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [flat, setFlat] = useState("");
  const [village, setVillage] = useState("");
  const [street, setStreet] = useState("");
  const [area, setArea] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [TDAN, setTDAN] = useState("");
  const [TCAN, setTCAN] = useState("");
  const [DOB, setDOB] = useState("");
  const [GST, setGST] = useState(false);
  const [GSTNum, setGSTNum] = useState(false);
  const [CIN, setCIN] = useState("");
  const [phone, setPhone] = useState();
  const [businessType, setBusinessType] = useState("");

  const [editProfile, setEditProfile] = useState(false);

  useEffect(() => {
    if (data) {
      const parsedAddressObj = JSON.parse(data.company_address);

      setFirmName(data.company_name);
      setEmail(data.company_email);
      setGST(data.GST);
      setGSTNum(data.gst_num);
      setCompanyPan(data.company_pan);
      setZipCode(data.company_zip_code);
      setPhone(data.company_num);
      setOfficeName(parsedAddressObj.officeName);
      setFlat(parsedAddressObj.flat);
      setVillage(parsedAddressObj.village);
      setStreet(parsedAddressObj.street);
      setArea(parsedAddressObj.area);
      setCity(parsedAddressObj.city);
      setState(parsedAddressObj.state);
      setCountry(parsedAddressObj.country);
      setDOB(data.compnay_DOB);
      setTDAN(data.tax_deduction_account_number);
      setTCAN(data.tax_collection_account_number);
      setCIN(data.CIN);
      setBusinessType(data.businessType);
    }
  }, [data]);

  const handleSubmit = () => {
    const address = {
      officeName,
      flat,
      village,
      street,
      area,
      city,
      state,
      country,
    };

    const dta = {
      company_name: firmName,
      email: data.email,
      company_email: email,
      company_address: JSON.stringify(address),
      phone: phone ? formatPhoneNumberIntl(phone) : "",
      company_zip_code: zipCode,
      company_pan: compnayPan,
      gst: GST,
      gst_num: GSTNum,
      DOB,
      tax_deduction_account_number: TDAN,
      tax_collection_account_number: TCAN,
      CIN,
      businessType,
    };

    axios
      .post(`https://server.abnca.in/users/firmProfile/update`, dta, {
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      })
      .then((res) => {
        window.alert(res.data.message);
        window.location.reload();
        if (res.data.status === 400) {
          if (res.data.message) {
            window.alert(res.data.message);
            window.location.reload();
          }
        }
      })
      .catch((err) => {
        window.alert("some error occured please check console");
        console.log(err);
      });
  };
  return (
    <div>
      <div className="px-3 pb-5">
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="text-right">Firm Profile</h4>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <label className="labels">Firm Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Firm name"
              value={firmName}
              onChange={(e) => setFirmName(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-6">
            <label className="labels">Firm PAN</label>
            <input
              type="text"
              className="form-control"
              value={compnayPan}
              onChange={(e) => setCompanyPan(e.target.value)}
              placeholder="Firm pan"
              disabled={!editProfile}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            <label className="labels">Firm Email ID</label>
            <input
              type="text"
              className="form-control"
              placeholder="Firm email id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Firm Phone Number</label>
            <PhoneInput
              placeholder="Enter firm phone number"
              value={phone}
              onChange={setPhone}
              className="form-control"
              defaultCountry="IN"
              countryOptionsOrder={["IN", "🌐", "AU", "SG", "AE", "GB", "US"]}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Date Of Birth</label>
            <input
              type="date"
              className="form-control"
              placeholder="Date of birth"
              value={DOB}
              onChange={(e) => setDOB(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Business Type</label>
            <select
              className="form-control"
              value={businessType}
              onChange={(e) => setBusinessType(e.target.value)}
              disabled={!editProfile}
            >
              <option value="">Select Business Type</option>
              <option value="central/state government">
                Central/State Government
              </option>
              <option value="statutory/autonomous body">
                Statutory/Autonomous Body
              </option>
              <option value="partnership or pvt ltd">
                Partnership or Pvt Ltd
              </option>
              <option value="branch/division of a partnership or pvt ltd">
                Branch/Division of a Partnership or Pvt Ltd
              </option>
              <option value="individual/huf">Individual/HUF</option>
              <option value="branch of individual business/sole prop">
                Branch of Individual Business/Sole Prop
              </option>
            </select>
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Name Of Office</label>
            <input
              type="text"
              className="form-control"
              placeholder="Name of office"
              value={officeName}
              onChange={(e) => setOfficeName(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Flat/Room/Door/Block No</label>
            <input
              type="text"
              className="form-control"
              placeholder="flat/Room/Door/Block No"
              value={flat}
              onChange={(e) => setFlat(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Name of Permisis/Building/Village</label>
            <input
              type="text"
              className="form-control"
              placeholder="Name of Permisis/Building/Village"
              value={village}
              onChange={(e) => setVillage(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Road/Street/Lane/Post office</label>
            <input
              type="text"
              className="form-control"
              placeholder="Road/Street/Lane/Post office"
              value={street}
              onChange={(e) => setStreet(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Area/Locality/Taluka/Sub-division</label>
            <input
              type="text"
              className="form-control"
              placeholder="Area/Locality/Taluka/Sub-division"
              value={area}
              onChange={(e) => setArea(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Town/City/District</label>
            <input
              type="text"
              className="form-control"
              placeholder="Town/City/District"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">State/Union Territory</label>
            <input
              type="text"
              className="form-control"
              placeholder="State/Union Territory"
              value={state}
              onChange={(e) => setState(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Firm Zip Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="Firm zip code"
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 d-flex align-items-center justify-content-between mt-3">
            <div className="d-flex col-md-3 align-items-center  gap-1">
              <input
                type="checkbox"
                checked={GST}
                onChange={(e) => setGST(e.target.checked)}
                disabled={!editProfile}
              />
              <label className="labels my-0 ml-2">GST</label>
            </div>
            {GST && (
              <div className="d-flex col-md-9 align-items-center">
                <label className="labels">GST Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="GST number"
                  value={GSTNum}
                  onChange={(e) => setGSTNum(e.target.value)}
                  disabled={!editProfile}
                />
              </div>
            )}
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Country</label>
            <CountryDropdown
              classes="form-control"
              value={country}
              onChange={(val) => setCountry(val)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Tax Deduction Account Number</label>
            <input
              type="text"
              className="form-control"
              placeholder="Tax Deduction Account Number"
              value={TDAN}
              onChange={(e) => setTDAN(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Tax Collection Account Number</label>
            <input
              type="text"
              className="form-control"
              placeholder="Tax Collection Account Number"
              value={TCAN}
              onChange={(e) => setTCAN(e.target.value)}
              disabled={!editProfile}
            />
          </div>
          <div className="col-md-12 mt-3">
            <label className="labels">Registration Nummber (CIN)</label>
            {/* change numInputs for number of inputs in reg no */}
            <OtpInput
              value={CIN}
              onChange={(value) => setCIN(value)}
              isDisabled={!editProfile}
              numInputs={21}
              separator={<>&nbsp;&nbsp;</>}
            />
          </div>
        </div>
        <div className="mt-5 text-center">
          {editProfile ? (
            <>
              <button
                className="btn btn-primary profile-button"
                type="button"
                onClick={handleSubmit}
              >
                Update Firm Profile
              </button>
              <button
                className="btn btn-danger ml-4 profile-button"
                type="button"
                onClick={() => setEditProfile(false)}
              >
                Cancel
              </button>
            </>
          ) : (
            <button
              className="btn btn-primary profile-button"
              type="button"
              onClick={() => setEditProfile(true)}
            >
              Edit Firm Profile
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FirmProfileForm;
